  // src/pages/Auth/Login/useLogin.js
import useAuthForm from '../../../hooks/useAuthForm';
import { login } from '../../../services/authService';
import validateByType from '../../../hooks/useFormValidation';

const useLogin = () => {
  const initialValues = {
    email: '',
    password: '',
  };

  return useAuthForm({
    initialValues,
    validateFn: (form) => validateByType('login', form),
    submitFn: login,
    onSuccessNavigateTo: '/dashboard',
    onNoSubscriptionNavigateTo: '/pricing'
  });
};

export default useLogin;
